import { PublicClientApplication } from '@azure/msal-browser';
import { MSAL_CONFIG } from 'src/config';

export default (): PublicClientApplication =>
    new PublicClientApplication(MSAL_CONFIG);
